import React from 'react';
import { useTranslation } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import menuArrow from '../../../icons/menu_arrow.svg'
import { LanguageSection, LanguageButton, Separator, PortfoliosButton, AboutUs, Languages, ExpandSectionIcon, Category, MobileSubNav, Subcategories, ButtonWrapper } from '../../PortfolioCategorySubNav/components/index.styled';
import ToyotaButton from '../../ToyotaButton';

export const PortfolioSubNavMobile = ({ category = 'materials', open, onChangeSection }) => {
  const { t, i18n } = useTranslation();
  const portfolioCategories = t(`PortfolioCategories`, { returnObjects: true })
  const toggleLanguage = e => {
    e.preventDefault()
    i18n.changeLanguage(e.target.value);
    document.location.reload()
  }

  return (
    <MobileSubNav open={open}>
      <Fade top>
        <>
          <PortfoliosButton open={open}>
            <span>{t('CategoriesData.title')}&nbsp;</span>
            <ExpandSectionIcon open={open} src={menuArrow} alt="Expand" height='16px' width='16px' />
          </PortfoliosButton>
          <Subcategories open={open} >
            {portfolioCategories.map(category => (
              <Category
                key={category.name}
                to={`/portfolios/${category.name}`}
                value={category.name}
              >
                <div onClick={onChangeSection}>
                  <span>
                    {t(`CategoriesData.categories.${category.name}`)}
                  </span>
                </div>
              </Category>
            ))}
          </Subcategories>
          <AboutUs to='/about' onClick={onChangeSection}>
            <span>
              {t('SiteNavData.about.title')}
            </span>
          </AboutUs>
          <Languages>
            <LanguageSection>
              <LanguageButton value='en' onClick={e => toggleLanguage(e)}>
                English
              </LanguageButton>
              <Separator>|</Separator>
              <LanguageButton value='ja' onClick={e => toggleLanguage(e)}>
                &nbsp;{t('Languages.japanese')}
              </LanguageButton>
            </LanguageSection>
          </Languages>
        </>
        <ButtonWrapper>
          <ToyotaButton href='#contact' onClick={onChangeSection}>
          {t('SiteNavData.contact.title')}
          </ToyotaButton>
        </ButtonWrapper>
      </Fade>
    </MobileSubNav>
  )
}
